import PersonFormFooter from './PersonFormFooter'

export default PersonFormFooter
